import { useState } from 'react';
import { Box } from '@mui/material';
import ViewportList from "./components/viewportList";
import ViewportDisplay from "./components/viewportDisplay";
import styles from "./10xViewport.module.css"

const TenxViewport = () => {
    // Handle changing display state when selecting a device on the list
    const [selectedDevice, setSelectedDevice] = useState<string | null>(null);

    return (
        <Box className={styles.Viewport}>
            <Box className={styles.Viewport_Display}>
                <ViewportDisplay selectedDevice={selectedDevice} />
            </Box>

            <Box className={styles.Viewport_List}>
                <ViewportList
                    onDeviceSelect={setSelectedDevice}
                    selectedDevice={selectedDevice}
                />
            </Box>
        </Box>
    )
}

export default TenxViewport;
